import {
    RaikoAlert, raikoAlertTypes,
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoStepper
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useState} from "react";
import SelectResidenceFromList from "./SelectResidenceFromList";
import ResidenceAddInfo from "./ResidenceAddInfo";

export default function ResidenceChoiceAdd({periodId,handleCloseDialogAdd}) {

    const [stepCounter, setStepCounter] = useState(0);
    const [residenceInfo, setResidenceInfo] = useState();

    function handleSelectNewResidence(residenceInfo) {
        setResidenceInfo(residenceInfo)
        setStepCounter(residenceSteps.RESIDENCE_INFO.activeStep)
    }


    return(
        <RaikoGridOneColumn  className={css`
              padding: .5rem 1rem 1rem 1rem;
              gap: 2rem;
              width: 100%`}>
            <RaikoStepper
                activeStep={stepCounter}
                orientation={"horizontal"}
                className={css`margin-bottom: 1rem;`}
                steps={[
                    residenceSteps.SELECT_RESIDENCE.title,
                    residenceSteps.RESIDENCE_INFO.title,
                ]}
            />
            {
                stepCounter === residenceSteps.SELECT_RESIDENCE.activeStep &&
                <SelectResidenceFromList selectResidence={handleSelectNewResidence}/>
            }
            {
                stepCounter === residenceSteps.RESIDENCE_INFO.activeStep &&
                <ResidenceAddInfo
                    periodId={periodId}
                    residenceInfo={residenceInfo}
                    handleBackPage={_ => {
                        setStepCounter(residenceSteps.SELECT_RESIDENCE.activeStep)
                    }}
                    handleCloseDialogAdd={handleCloseDialogAdd}
                />
            }
        </RaikoGridOneColumn>
    )
}
const residenceSteps = {
    SELECT_RESIDENCE: {
        activeStep: 0,
        title: "انتخاب اقامتگاه"
    }, RESIDENCE_INFO: {
        activeStep: 1,
        title: "اطلاعات اقامتگاه"
    },
}